import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

import { AddAdGroupMemberRequest } from '../../types/active-directory'
const { ACTIVE_DIRECTORY_API_URL } = CONSTANT

const getStoredUserEmail = (): string => {
	const oktaTokenStorage = localStorage.getItem('okta-token-storage')
	if (!oktaTokenStorage) {
		return ''
	}

	try {
		const parsedStorage = JSON.parse(oktaTokenStorage)
		return (
			parsedStorage?.idToken?.claims?.email ||
			parsedStorage?.idToken?.idToken?.claims?.email ||
			''
		)
	} catch {
		return ''
	}
}

const buildLocalRequesterHeaders = (): HeadersInit => {
	if (!ACTIVE_DIRECTORY_API_URL.includes('localhost')) {
		return {}
	}

	const currentUserEmail = getStoredUserEmail()
	if (!currentUserEmail) {
		return {}
	}

	return {
		'X-SSP-Current-User': currentUserEmail
	}
}

export default async function addAdGroupMember(
	addAdGroupMemberRequest: AddAdGroupMemberRequest
): Promise<any> {
	const response = await fetchWithAuthorizationHeader(`${ACTIVE_DIRECTORY_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'CREATE',
			...buildLocalRequesterHeaders()
		},
		body: JSON.stringify(addAdGroupMemberRequest)
	})
	const payload = await response.json().catch(() => null)

	if (!response.ok) {
		const message =
			(typeof payload?.detail === 'string' && payload.detail) ||
			(typeof payload?.error === 'string' && payload.error) ||
			'Failed to add Active Directory group members'

		throw new Error(message)
	}

	return payload
}
